/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { useAthletesByIds } from '@api/hooks';
import { AthleteSelect, InfoItem, SortableArrayField, AddSelectEntity, ContentModuleModal } from '@molecules';
import { NO_MARGIN_BOTTOM } from '@constants';

import Form from '../Form';

import Item from './item';
import { FORM_FIELD, FORM_FIELDS, INITIAL_VALUES } from './constant';

const HeroAthletesCarousel = ({
  initialValues = INITIAL_VALUES,
  previewImg,
  onDelete,
  onSubmit,
  visible,
  errors,
  hide,
}) => {
  const [form] = Form.useForm(FORM_FIELDS);
  const athletesQuery = useAthletesByIds(initialValues[FORM_FIELD.ATHLETES.name]);

  React.useEffect(() => {
    if (visible && athletesQuery.status === 'success') {
      form.setFieldsValue({ [FORM_FIELD.ATHLETES.name]: athletesQuery.athletes });
    }
  }, [athletesQuery.athletes, athletesQuery.status, form, visible]);

  const handleClose = () => {
    form.resetFields();
    hide();
  };

  const handleSubmit = (values) => {
    onSubmit(values);
    handleClose();
  };

  const handleAddAthlete = async (newAthlete) => {
    const previousAthletes = form.getFieldValue(FORM_FIELD.ATHLETES.name);
    form.setFieldsValue({ [FORM_FIELD.ATHLETES.name]: [...previousAthletes, newAthlete] });
  };

  return (
    <ContentModuleModal
      subtitle="Show up to 4 featured athletes in a carousel"
      okText={onDelete ? 'SAVE CHANGES' : 'ADD ATHLETE'}
      title="Hero athletes carousel"
      heroImageSrc={previewImg}
      onCancel={handleClose}
      onSubmit={form.submit}
      onDelete={onDelete}
      visible={visible}
      errors={errors}
    >
      <AddSelectEntity addText="ADD ATHLETE" onAdd={handleAddAthlete} select={AthleteSelect} />
      <Form
        onSerializedFinish={handleSubmit}
        initialValues={initialValues}
        name="heroAthletesCarousel"
        layout="vertical"
        form={form}
      >
        <SortableArrayField {...FORM_FIELD.ATHLETES} style={NO_MARGIN_BOTTOM} form={form} withPlaceholder withCount>
          {(athlete) => <InfoItem image={athlete.image}>{athlete.fullName}</InfoItem>}
        </SortableArrayField>
      </Form>
    </ContentModuleModal>
  );
};

HeroAthletesCarousel.Item = Item;

export default HeroAthletesCarousel;
